import { PropsWithChildren } from 'react';

import css from './styles.module.css';

/**
 * A full-width action bar below the notice body, tinted to match the variant.
 *
 * Use this when the actions belong on their own row. For an action that sits
 * inline beside the text, use `Notice.Actions` instead.
 */
export function NoticeFooter({ children }: PropsWithChildren) {
  return <div className={css.footer}>{children}</div>;
}
